//---- STORE ----
//getters
export const GET_HOSTNAME = 'store/GET_HOSTNAME';
export const GET_PRODUCTS_RESULT = 'store/GET_PRODUCTS_RESULT';
export const GET_BESTSELLERS_RESULT = 'store/GET_BESTSELLERS_RESULT';
export const GET_NB_PRODUCTS_DISPLAY = 'store/GET_NB_PRODUCTS_DISPLAY';

//action
export const SET_HOSTNAME= 'store/SET_HOSTNAM';
export const ADD_PRODUCT_RESULT = 'store/ADD_PRODUCT_RESULT';
export const ADD_BESTSELLER_RESULT = 'store/ADD_BESTSELLER_RESULT';
export const UPDATE_PRODUCT_RESULT = 'store/UPDATE_PRODUCT_RESULT';
export const UPDATE_NB_PRODUCTS_DISPLAY= 'store/UPDATE_NB_PRODUCTS_DISPLAY';

//Mutation
export const MUTATE_SET_HOSTNAME = 'store/MUTATE_SET_HOSTNAME';
export const MUTATE_ADD_PRODUCT_RESULT = 'store/MUTATE_ADD_PRODUCT_RESULT';
export const MUTATE_ADD_BESTSELLER_RESULT = 'store/MUTATE_ADD_BESTSELLER_RESULT';
export const MUTATE_UPDATE_PRODUCT_RESULT = 'store/MUTATE_UPDATE_PRODUCT_RESULT';
export const MUTATE_UPDATE_NB_PRODUCTS_DISPLAY = 'store/MUTATE_UPDATE_NB_PRODUCTS_DISPLAY';

//---- COLLECTION ----
//getters
export const GET_COLLECTION = 'collection/GET_COLLECTION';
export const GET_CATEGORY = 'collection/GET_CATEGORY';
export const GET_CATEGORIES = 'collection/GET_CATEGORIES';
export const GET_ID_CATEGORY = 'collection/GET_ID_CATEGORY';
export const GET_CATEGORY_PRODUCTS = 'collection/GET_CATEGORY_PRODUCTS';
export const GET_NB_PRODUCT_DISPLAY = 'collection/GET_NB_PRODUCT_DISPLAY';
export const GET_CONTENT1 = 'collection/GET_CONTENT1';
export const GET_CONTENT2 = 'collection/GET_CONTENT2';
export const GET_ASSOCIATIONS = 'collection/GET_ASSOCIATIONS';
export const GET_FEATURES = 'collection/GET_FEATURES';
export const GET_ATTRIBUTES_GROUP = 'collection/GET_ATTRIBUTES_GROUP';


//action
export const LOAD_DATA_COLLECTION = 'collection/LOAD_DATA_COLLECTION';
export const LOAD_DATA_CATEGORY = 'collection/LOAD_DATA_CATEGORY';
export const INIT_CATEGORY = 'collection/INIT_CATEGORY';
export const INIT_CATEGORIES = 'collection/INIT_CATEGORIES';
export const INIT_COLLECTION = 'collection/INIT_COLLECTION';
export const INIT_CATEGORY_PRODUCTS = 'collection/INIT_CATEGORY_PRODUCTS';
export const INIT_BESTSELLER = 'collection/INIT_BESTSELLER';
export const INIT_ATTRIBUTES_FEATURES = 'collection/INIT_ATTRIBUTES_FEATURES';
export const ADD_ATTRIBUTES_FEATURES = 'collection/ADD_ATTRIBUTES_FEATURES';

//Mutation
export const MUTATE_LOAD_DATA_COLLECTION = 'collection/MUTATE_LOAD_DATA_COLLECTION';
export const MUTATE_INIT_COLLECTION = 'collection/MUTATE_INIT_COLLECTION';
export const MUTATE_INIT_CATEGORY = 'collection/MUTATE_INIT_CATEGORY';
export const MUTATE_INIT_CATEGORIES = 'collection/MUTATE_INIT_CATEGORIES';
export const MUTATE_INIT_PRODUCT_CATEGORY = 'collection/MUTATE_INIT_PRODUCT_CATEGORY';
export const MUTATE_INIT_BESTSELLERS = 'collection/MUTATE_INIT_BESTSELLERS';
export const MUTATE_ADD_ATTRIBUTES_GROUP = 'collection/MUTATE_ADD_ATTRIBUTES_GROUP';
export const MUTATE_ADD_FEATURES = 'collection/MUTATE_ADD_FEATURES';
export const MUTATE_ADD_CATEGORY_IMAGE = 'collection/MUTATE_ADD_CATEGORY_IMAGE';
export const MUTATE_ADD_COLLECTION_IMAGE = 'collection/MUTATE_ADD_COLLECTION_IMAGE';


//---- PRODUCT -----

//getters
export const GET_PRODUCTS = 'products/GET_PRODUCTS';
export const GET_PRODUCT = 'products/GET_PRODUCT';
export const GET_URL_PRODUCT = 'products/GET_URL_PRODUCT';

//action
export const LOAD_PRODUCT    = 'products/LOAD_PRODUCT';
export const LOAD_BESTSELLER = 'bestsellers/LOAD_BESTSELLER';

//Mutation
export const MUTATE_ADD_PRODUCT = 'products/MUTATE_ADD_PRODUCT';
export const MUTATE_ADD_BESTSELLER = 'bestsellers/MUTATE_ADD_BESTSELLER';
export const MUTATE_ADD_COMBINATION = 'products/MUTATE_ADD_COMBINATION';
export const MUTATE_ADD_PRODUCT_OPTION_VALUE = 'products/MUTATE_ADD_PRODUCT_OPTION_VALUE';

//---- Filters ----
//getters
export const GET_FILTER_BY_ID = 'filters/GET_FILTER_BY_ID';
export const GET_FILTER_FEATURES = 'filters/GET_FILTER_FEATURES';
export const GET_FILTER_ATTRIBUTES = 'filters/GET_FILTER_ATTRIBUTES';
export const GET_VALUES_ATTRIBUTES = 'filters/GET_VALUES_ATTRIBUTES';
export const GET_VALUE_FEATURES = 'filters/GET_VALUE_FEATURES';

//action
export const TOGGLE_FILTER = 'filters/TOGGLE_FILTER';
export const ADD_FILTER_CHECKED = 'filters/ADD_FILTER_CHECKED';
export const DELETE_FILTER_CHECKED = 'filters/DELETE_FILTER_CHECKED';

//Mutation
export const MUTATE_INIT_FILTER_VALUE = 'filters/MUTATE_INIT_FILTER_VALUE';
export const MUTATE_ADD_FILTER_CHECKED  = 'filters/MUTATE_ADD_FILTER_CHECKED';
export const MUTATE_DELETE_FILTER_CHECKED = 'filters/MUTATE_DELETE_FILTER_CHECKED';




// WEBPACK FOOTER //
// ./src/store/types.js